export default function getResource(label) {
    const resources = { sortBy: 'Trier par' };

    return resources[label];
}
